import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { Calendar, Lock, Mail } from 'lucide-react';
import { API_BASE_URL, axiosConfig } from '../../config';
import axios from 'axios';
import './LoginPage.css';

const LoginPage = () => {
    const navigate = useNavigate();
    const { login, isAuthenticated } = useAuth();
    const [formData, setFormData] = useState({ email: '', password: '' });
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const [showForgotPassword, setShowForgotPassword] = useState(false);
    const [forgotPasswordEmail, setForgotPasswordEmail] = useState('');
    const [forgotPasswordLoading, setForgotPasswordLoading] = useState(false);
    const [forgotPasswordMessage, setForgotPasswordMessage] = useState('');

    // Если уже авторизован - редирект на главную
    React.useEffect(() => {
        if (isAuthenticated) {
            navigate('/');
        }
    }, [isAuthenticated, navigate]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
        setError('');
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError('');

        const result = await login(formData.email, formData.password);

        if (result.success) {
            navigate('/');
        } else {
            setError(result.message);
        }

        setLoading(false);
    };

    const handleForgotPassword = async (e) => {
        e.preventDefault();
        setForgotPasswordLoading(true);
        setForgotPasswordMessage('');

        try {
            const response = await axios.post(
                `${API_BASE_URL}/auth/forgot-password`,
                { email: forgotPasswordEmail },
                axiosConfig
            );

            setForgotPasswordMessage('Новый пароль отправлен на вашу почту');
            setForgotPasswordEmail('');
            setTimeout(() => {
                setShowForgotPassword(false);
                setForgotPasswordMessage('');
            }, 3000);
        } catch (error) {
            console.error('Ошибка восстановления пароля:', error);
            setForgotPasswordMessage(error.response?.data?.message || 'Ошибка восстановления пароля');
        } finally {
            setForgotPasswordLoading(false);
        }
    };

    return (
        <div className="login-page">
            <div className="login-container">
                <div className="login-header">
                    <Calendar size={48} className="login-icon" />
                    <h1>Календарь</h1>
                    <p>Система управления расписанием</p>
                </div>

                <form onSubmit={handleSubmit} className="login-form">
                    {error && <div className="error">{error}</div>}

                    <div className="form-group">
                        <label htmlFor="email">
                            <Mail size={18} />
                            Email
                        </label>
                        <input
                            type="email"
                            id="email"
                            name="email"
                            value={formData.email}
                            onChange={handleChange}
                            required
                            placeholder="your@email.com"
                            autoComplete="email"
                        />
                    </div>

                    <div className="form-group">
                        <label htmlFor="password">
                            <Lock size={18} />
                            Пароль
                        </label>
                        <input
                            type="password"
                            id="password"
                            name="password"
                            value={formData.password}
                            onChange={handleChange}
                            required
                            placeholder="••••••••"
                            autoComplete="current-password"
                        />
                    </div>

                    <button
                        type="submit"
                        className="btn btn-primary btn-login"
                        disabled={loading}
                    >
                        {loading ? (
                            <>
                                <div className="spinner-small"></div>
                                Вход...
                            </>
                        ) : (
                            'Войти'
                        )}
                    </button>

                    <div className="forgot-password">
                        <button
                            type="button"
                            className="btn-link"
                            onClick={() => setShowForgotPassword(true)}
                        >
                            Забыли пароль?
                        </button>
                    </div>
                </form>
            </div>

            {/* Модальное окно восстановления пароля */}
            {showForgotPassword && (
                <div className="modal-overlay">
                    <div className="modal">
                        <div className="modal-header">
                            <h3>Восстановление пароля</h3>
                            <button
                                type="button"
                                className="modal-close"
                                onClick={() => {
                                    setShowForgotPassword(false);
                                    setForgotPasswordEmail('');
                                    setForgotPasswordMessage('');
                                }}
                            >
                                ×
                            </button>
                        </div>
                        <div className="modal-body">
                            <p>Введите ваш email для восстановления пароля:</p>
                            <form onSubmit={handleForgotPassword}>
                                <div className="form-group">
                                    <label htmlFor="forgotEmail">Email</label>
                                    <input
                                        type="email"
                                        id="forgotEmail"
                                        value={forgotPasswordEmail}
                                        onChange={(e) => setForgotPasswordEmail(e.target.value)}
                                        required
                                        placeholder="your@email.com"
                                    />
                                </div>
                                {forgotPasswordMessage && (
                                    <div className={`message ${forgotPasswordMessage.includes('отправлен') ? 'success' : 'error'}`}>
                                        {forgotPasswordMessage}
                                    </div>
                                )}
                                <div className="modal-actions">
                                    <button
                                        type="button"
                                        className="btn btn-secondary"
                                        onClick={() => {
                                            setShowForgotPassword(false);
                                            setForgotPasswordEmail('');
                                            setForgotPasswordMessage('');
                                        }}
                                    >
                                        Отмена
                                    </button>
                                    <button
                                        type="submit"
                                        className="btn btn-primary"
                                        disabled={forgotPasswordLoading}
                                    >
                                        {forgotPasswordLoading ? (
                                            <>
                                                <div className="spinner-small"></div>
                                                Отправка...
                                            </>
                                        ) : (
                                            'Восстановить'
                                        )}
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default LoginPage;

